import { MutationTree } from 'vuex';
import { StatisticState, DetailItem, ViberGroupItem } from './types';

export const mutations: MutationTree<StatisticState> = {
  setViberStatisticDetail: (state, data: DetailItem[]) => state.viberStatisticDetail = data,
  pushViberStatisticDetail: (state, data: DetailItem[]) => state.viberStatisticDetail = state.viberStatisticDetail.concat(data),
  setViberStatisticGroup: (state, data: ViberGroupItem[]) => state.viberStatisticGroup = data
};